export const formatDate = (dateStr) => {
  if (!dateStr) return "No date";
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
